import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useAdminColors } from '@/hooks/admin/useAdminColors';

export const PaginationControls = ({
  page,
  totalPages,
  isFetching,
  pagingForward,
  onPrev,
  onNext,
}: {
  page: number;
  totalPages: number;
  isFetching: boolean;
  pagingForward: boolean;
  onPrev: () => void;
  onNext: () => void;
}) => {
  const { redesign, semantic } = useAdminColors();
  return (
    <View style={[styles.container, { borderTopColor: redesign.card.border }]}>
      <View style={styles.info}>
        <Text style={[styles.infoText, { color: redesign.text.muted }]}>
          Page {page + 1} of {totalPages}
        </Text>
      </View>
      <View style={styles.controls}>
        <TouchableOpacity
          style={[
            styles.button,
            { backgroundColor: redesign.accent.blueBg },
            page === 0 && { backgroundColor: redesign.glass.buttonBg },
          ]}
          onPress={onPrev}
          disabled={page === 0 || isFetching}
          accessibilityLabel="Previous page"
          accessibilityRole="button"
        >
          <Text style={[styles.buttonText, { color: semantic.text.link }]}>
            Previous
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[
            styles.button,
            { backgroundColor: redesign.accent.blueBg },
            page >= totalPages - 1 && { backgroundColor: redesign.glass.buttonBg },
            isFetching && pagingForward && styles.buttonLoading,
          ]}
          onPress={onNext}
          disabled={page >= totalPages - 1 || isFetching}
          accessibilityLabel="Next page"
          accessibilityRole="button"
        >
          <Text style={[styles.buttonText, { color: semantic.text.link }]}>
            Next
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 16,
    borderTopWidth: 1,
  },
  info: { alignItems: 'center', marginBottom: 12 },
  infoText: { fontSize: 14, fontWeight: '500' },
  controls: { flexDirection: 'row', justifyContent: 'center', gap: 12 },
  button: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
    minWidth: 100,
    alignItems: 'center',
  },
  buttonLoading: { opacity: 0.9 },
  // buttonText color is applied inline (semantic.text.link): these are tinted
  // "ghost" buttons whose fill is a ~10% blue wash, on which white is invisible.
  buttonText: { fontSize: 14, fontWeight: '600' },
});
